module.exports = "<footer>\n  <div class=\"content\">\n    <span>vinocorn.com</span>\n    <span>copyright © All rights reserved</span>\n  </div>\n</footer>"